module.exports = __webpack_public_path__ + "media/fonts/fondamento/Fondamento-Italic-a178d617b6d426482421985fd647e3b7.ttf";